import { render, staticRenderFns } from "./node-inspector.vue?vue&type=template&id=c4c59352&scoped=true&v-if=node&"
import script from "./node-inspector.vue?vue&type=script&lang=ts&"
export * from "./node-inspector.vue?vue&type=script&lang=ts&"
import style0 from "./node-inspector.vue?vue&type=style&index=0&id=c4c59352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c59352",
  null
  
)

export default component.exports